// src/version.ts
export const appVersion = "3.12";
